<template>
  <v-menu
    v-model="menu_ativo"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{}">
      <button class="btn-color-filter mt-n4 ml-2" @click="inverterStatusMenu()">
        <v-icon size="18">mdi-filter</v-icon>
        <span class="ml-1 mr-2">Filtros</span>
      </button>
    </template>

    <v-card class="pb-2 w-525 border-gray-500" elevation="10">
      <v-card-title class="pl-4 pr-1 py-2">
        <div>
          <p class="ma-0 font-18 text-gray-900">Filtragem de produtos</p>
          <p class="ma-0 font-12 font-weight-regular mt-n3 text-gray-200">Selecione o que você deseja considerar na análisea</p>
        </div>

        <v-spacer />

        <v-btn icon @click="inverterStatusMenu()">
          <v-icon size="22">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pl-2 pr-1">
        <div class="mx-2">
          <v-checkbox
            v-model="FILTROS_COMPUTED.grupo_x_filial"
            label="Filtro por filial?"
            class="ml-n2 mb-n3"
            style="max-width: 250px;"
          />

          <SysFilialGrupoAutocomplete
            v-if="FILTROS_COMPUTED.grupo_x_filial"
            v-model="FILTROS_COMPUTED.filial"
            outlined
            dense
            label="Selecione a filial"
          />

          <SysGrupoAutocomplete
            v-else
            v-model="FILTROS_COMPUTED.grupo"
            outlined
            dense
            label="Selecione o grupo"
          />

          <SysSegmentoAutocomplete
            v-model="FILTROS_COMPUTED.segmentos"
            outlined
            dense
            clearable
            label="Selecione os segmentos"
            multiple
          />

          <SysLinhas
            v-model="filtros.linhas"
            label="Linhas"
            :qtde-visivel-selecionados="1"
            outlined
            multiple
            hide-details
            clearable
          />

          <SysFornecedorAutocomplete
            v-model="FILTROS_COMPUTED.fornecedores"
            outlined
            dense
            clearable
            label="Selecione os forncedores"
            multiple
            class="mt-6"
            :idsSegmento="FILTROS_COMPUTED.segmentos"
            :idsComprador="FILTROS_COMPUTED.compradores"
          />

          <SysCompradorAutocomplete
            v-model="FILTROS_COMPUTED.compradores"
            outlined
            dense
            clearable
            label="Selecione os compradores"
            multiple
            class="mt-0"
            :idsSegmento="FILTROS_COMPUTED.segmentos"
          />
        </div>
      </v-card-text>

      <div class="d-flex px-2">
        <v-spacer />

        <v-btn small color="#042333" dark @click="aplicarFiltros">
          filtrar
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import SysGrupoAutocomplete from '@/components/utils/crud/SysGrupoAutocomplete.vue';
import SysFilialGrupoAutocomplete from '@/components/utils/crud/SysFilialGrupoAutocomplete.vue';
import SysSegmentoAutocomplete from '@/components/utils/crud/SysSegmentoAutocomplete.vue';
import SysLinhas from '@/components/utils/crud/SysLinhasAutocomplete.vue';
import SysFornecedorAutocomplete from '@/components/utils/crud/SysFornecedorAutocomplete.vue';
import SysCompradorAutocomplete from '@/components/utils/crud/SysCompradorAutocomplete.vue';

export default {
  components: {
    SysGrupoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysSegmentoAutocomplete,
    SysLinhas,
    SysFornecedorAutocomplete,
    SysCompradorAutocomplete
  },
  model: {
    prop: 'filtros',
    event: 'change-filtros',
  },
  props: {
    filtros: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    menu_ativo: false
  }),
  computed: {
    FILTROS_COMPUTED: {
      get() { return this.filtros },
      set(valor) { this.$emit('change-filtros', valor) }
    }
  },
  methods: {
    inverterStatusMenu() {
      this.menu_ativo = !this.menu_ativo;
    },
    aplicarFiltros() {
      this.$emit('reiniciar-tela-compra-parametrizacao');
      this.menu_ativo = false;
    }
  }
}
</script>

<style scoped>
.btn-color-filter {
  background-color: #E9E9E9;
  border: none;
  border-radius: 3px;
  padding: 8px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}
</style>
